/* eslint-disable arrow-body-style */
import React, { useState, useEffect, useMemo, CSSProperties } from 'react';
import { Row, Col, Bubble } from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import { isGreater } from '@/pages/dashboard/pages/overview/_config/common';
import {
  formatPercentNum,
  formatNum,
  formatFilterValues,
} from '@/pages/dashboard/utils/utils';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import { METRICS_INFO, explainMap, titltText,TAB_NAME } from '../../_config/constant';
import MetricsCard from '../MetricsCard';
import Loadings from '@/pages/dashboard/components/Loadings';
import LoadingFailed from '@/pages/dashboard/components/LoadingFailed';
import NoData from '@/pages/dashboard/components/SelectorMultiple/components/NoData';
import { getExplainVal } from '@/pages/dashboard/utils/getExplainVal';

import './index.scss';
interface Props {
  explainInfo: any;
  formValue: any;
  gameCode: string;
  filterLoading: boolean;
}

const INT_LIST = ['Install', 'Register'];
const NoSpendKeyPerformanceMetrics = (props: Props) => {
  const { explainInfo, formValue, filterLoading, gameCode } = props;
  const { filterValue, timeType,diff} = formValue;
  const { rangeTime, ...filters } = filterValue || {};
  const [isHover, setIsHover] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { locale, getLocalText } = useLocal();
  const isChange = isGreater(timeType?.toUpperCase(), rangeTime);
  const defaultCardList = [
    {
      metricsName: 'Install',
      value: '-',
      dod: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
      sdlw: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
    },
    {
      metricsName: 'Register',
      value: '-',
      dod: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
      sdlw: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
    },
    {
      metricsName: 'D2(T-1)',
      value: '-',
      dod: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
      sdlw: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
    },
    {
      metricsName: 'D3(T-2)',
      value: '-',
      dod: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
      sdlw: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
    },
    {
      metricsName: 'D7(T-6)',
      value: '-',
      dod: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
      sdlw: {
        value: '-',
        startTime: '',
        endTime: '',
        startValue: '',
        endValue: '',
      },
    },
  ];
  const [originData, setOriginData] = useState(null);

  // 获取指标解释说明
  const metricsInfo = useMemo(() => {
    return ['Install', 'Register', 'D2(T-1)_D', 'D3(T-2)', 'D7(T-6)']?.map(
      (name) => {
        const newTitle = titltText[name] ? getLocalText(titltText[name]) : name;
        const explain = getExplainVal(explainInfo, `card_${explainMap?.[name]}`, locale);
        return {
          name: newTitle,
          explanation: explain?.replace(/\\n/g, '<br/>'),
        };
      },
    );
  }, [explainInfo, locale]);

  // 根据不同的数据类型返回不同的字符串
  const getFormateStr = (type: any, value: any, name: any) => {
    // 这三个指标数值超过百万显示单位M|B
    // const isMillionMetrics = new RegExp('^(DAU|Revenue|New)$', 'g').test(metrics_name) && value >= 1000000
    switch (type) {
      case 'int':
        // if (isMillionMetrics) {
        //   return unitConversionMillion(value)
        // }
        return formatNum(value, false, INT_LIST?.includes(name));
      case 'percent':
        return formatPercentNum(parseFloat(value), 2);
      case 'bigPercent':
        return formatPercentNum(parseFloat(value), 2, false, true);
    }
  };

  const formatData = (cardData: any) => {
    const keyMap: any = {
      Day: ['dod', 'sdlw'],
      Week: ['wow', 'swlm'],
      Month: ['mom', 'smly'],
    };
    const keyArr = keyMap[timeType];
    return cardData?.map((item: any) => {
      const {
        [keyArr[0]]: {
          show_value: dodValue,
          last_time: dodLastTime,
          last_value: dodLastValue,
          this_time: dodThisTime,
          this_value: dodThisValue,
        },
        [keyArr[1]]: {
          show_value: sdlwValue,
          last_time: sdlwLastTime,
          last_value: sdlwLastValue,
          this_time: sdlwThisTime,
          this_value: sdlwThisValue,
        },
        change: {
          last_time: changeLastTime,
          this_time: changeThisTime,
          this_value: changeThisValue,
          last_value: changeLastValue,
          show_value: changeShowValue,
        },
        value,
        metrics_name,
      } = item;
      let { title = '', type } = METRICS_INFO[metrics_name] ?? {};

      return {
        metricsName: metrics_name,
        value: getFormateStr(type, value, title),
        dod: {
          value: dodValue || '-',
          startTime: dodThisTime,
          endTime: dodLastTime,
          startValue: getFormateStr(type, dodThisValue, title),
          endValue: getFormateStr(type, dodLastValue, title),
        },
        sdlw: {
          value: sdlwValue || '-',
          startTime: sdlwThisTime,
          endTime: sdlwLastTime,
          startValue: getFormateStr(type, sdlwThisValue, title),
          endValue: getFormateStr(type, sdlwLastValue, title),
        },
        change: {
          value: changeShowValue,
          startTime: changeThisTime,
          endTime: changeLastTime,
          startValue: getFormateStr(type, changeThisValue, title),
          endValue: getFormateStr(type, changeLastValue, title),
        },
      };
    });
  };

  const cardData = useMemo(() => {
    let cardData = originData ? formatData(originData) : defaultCardList;

    return cardData?.map((dataItem: any) => {
      let {
        title = '',
        font = '',
        end = '',
      } = METRICS_INFO[dataItem?.metricsName] ?? {};
      title = `${title}${end}`;
      // UA多天标题改变（周月属于多天）
      if (isChange || timeType === 'Week' || timeType === 'Month') {
        title = `${font}${title}`;
      }
      const matchKey = titltText[dataItem?.metricsName]
        ? getLocalText(titltText[dataItem?.metricsName])
        : dataItem?.metricsName;

      return {
        ...dataItem,
        metricsName: titltText[title] ? getLocalText(titltText[title]) : title,
        metricsDesc: metricsInfo?.find((item) => item?.name === matchKey)
          ?.explanation,
      };
    });
  }, [originData, locale]);

  const update = () => {

    const params = {
      period: TAB_NAME[timeType],
      game_code: gameCode,
      start_time: rangeTime?.[0],
      end_time: rangeTime?.[1],
      filters:formatFilterValues(filters),
    };

    setLoading(true);
    setError(false);
    dashboardRequest({
      url: `/api/v1/dashboard/ua/no_spend/key_performance_metrics`,
      method: 'post',
      data: params,
    })
      .then(({ card_list }: any = {}) => {
        setOriginData(card_list);
        setError(false);
      })
      .catch((err) => {
        setError(true);
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (filterLoading) return;
    update();
  }, [formValue, filterLoading]);

  const getContainerHeight = (): string => {
    const cardHeight = isChange || !rangeTime ? 123 : 141;

    return `${cardHeight}px`;
  };

  return (
    <div  className='dbd-ua-metrics-box dbd-ua-metrics-box-no-spend'
      style={{ '--dbd-ua-loding-fail-no-data-height': getContainerHeight() } as CSSProperties}
    >
      <Row>
        <Col>
          <div className="overlay-title">
            <span>{getLocalText('overview_Key_Performance_Metrics')}</span>
            <Bubble
              dark
              className='dbd-ua-metrics-bubble'
              placement="top"
              content={
                <>
                  {metricsInfo?.map(({ name, explanation }: any) => {
                    name = name?.replaceAll('\\n', '<br/>') || '';
                    explanation = explanation?.replaceAll('\\n', '<br/>') || '';
                    return (
                      <div>
                        {name && (
                          <h6 dangerouslySetInnerHTML={{ __html: name }} />
                        )}
                        {explanation && (
                          <p
                            dangerouslySetInnerHTML={{ __html: explanation }}
                          />
                        )}
                      </div>
                    );
                  })}
                </>
              }
            >
              <i
                className="ua-icon-right"
                onMouseOver={() => {
                  setIsHover(true);
                }}
                onMouseOut={() => {
                  setIsHover(false);
                }}
              >
                <SvgIcon
                  className="select-header-ic"
                  type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
                />
              </i>
            </Bubble>
          </div>
        </Col>
      </Row>

      <Row>
        {loading ? (
          <div className='dbd-ua-loding-fail-no-data'>
            <Loadings />
          </div>
        ) : error ? (
          <div className='dbd-ua-loding-fail-no-data'>
            <LoadingFailed />
          </div>
        ) : cardData?.length > 0 ? (
          <>
            {cardData.map((val: any) => {
              return (
                <Col span={4} className="dbd-no-spend-card-item">
                  <MetricsCard
                    isChange={isChange}
                    data={val}
                    timeType={timeType}
                  />
                </Col>
              );
            })}
          </>
        ) : (
          <div className='dbd-ua-loding-fail-no-data'>
            <NoData />
          </div>
        )}
      </Row>
    </div>
  );
};

export default NoSpendKeyPerformanceMetrics;
